import React, { useState, useContext } from "react";
import { Stack, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import moment from "moment";
// src
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import { UPDATE_ATTENDANCE } from "../../Schema/Attendance";

export default function AttendanceAction({
  setRefetch,
  dateVal,
  attended_id,
  editData,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  // console.log("dateVal", moment(dateVal).format("DD-MM-YYYY"));

  const statusAttendance = [
    {
      state: "Presence",
      color: "#0200f6",
      label: "Presence",
    },
  ];


  const [updateAttendance] = useMutation(UPDATE_ATTENDANCE, {
    onCompleted: ({ updateAttendance }) => {
      // console.log("updateAttendance::", updateAttendance);
      setLoading(false);
      if (updateAttendance?.is_success === true) {
        setAlert(true, "success", updateAttendance?.message);
        setRefetch();
      } else {
        setAlert(true, "error", updateAttendance?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateAtt = async (attendance_status) => {
    setLoading(true);
    await updateAttendance({
      variables: {
        id: editData?._id,
        input: {
          attendance_status,
        },
      },
    });
  };

  return (
    <div>
      <Stack direction="row" spacing={10}>
        <Stack direction="row">
          {statusAttendance?.map((stat, index) => (
            <Stack direction="row" spacing={0.2} key={index}>
              <Checkbox
                // disabled={checkLoading}
                style={{ color: stat?.color }}
                checked={
                  editData?.attendance_status === "Presence" ? true : false
                }
                onClick={() => handleUpdateAtt( editData?.attendance_status === "Presence" ? '': 'Presence')}
              />

              <Stack direction="column" justifyContent="center">
                <Typography>{stat?.label}</Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </div>
  );
}
